// Use $ instead of $ without replacing global $
(function ($) {

  function setAttr() {
    var text;
    $('.col-three-grid .grid-wrapper h3').each(function () {
      // console.log(this);
      text = $(this).text().trim();
      // console.log(text);
      $(this).attr('data-title', text);
    });
  }

  function setAttrText() {
    var text;
    $('.col-three-grid .grid-wrapper h3').each(function () {
      text = $(this).text().trim();
      $(this).attr('data-title', text);
      $(this).parents('.col-three-grid').find('.year-wrapper').append('<span data-type=' + text + '>' + text + '</span>');
    });
  }

  $(document).ready(function () {

    $('.col-three-grid .grid-wrapper .card-box .card-body .inner-content h4').matchHeight({byRow: 0});
    $('.col-three-grid .grid-wrapper .card-box .card-body .inner-content').matchHeight();

    setTimeout(function () {
      limit_lines('.col-three-grid .grid-wrapper .card-box .card .card-body .inner-content p', 3);
      limit_lines('.col-three-grid .grid-wrapper .card-box .card-body .inner-content h4', 2);
    }, 1500);

    // $('.col-three-grid .filter-outer .filter-wrap .year-wrapper span').on('click', function() {
    //     // fetch the class of the clicked item
    //     var ourClass = $(this).attr('class');
    //     var active_year = $('.col-three-grid .filter-outer .filter-wrap .year-wrapper span');
    //
    //     // reset the active class on all the buttons
    //     $(active_year).removeClass('active');
    //     // update the active state on our clicked button
    //     $(this).addClass('active');
    //
    //     if(ourClass == 'all') {
    //         // show all our items
    //         $('.col-three-grid .grid-wrapper').children('div.card-box').show();
    //     }
    //     else {
    //         // hide all elements that don't share ourClass
    //         $('.col-three-grid .grid-wrapper').children('div:not(.' + ourClass + ')').hide();
    //         // show all elements that do share ourClass
    //         $('.col-three-grid .grid-wrapper').children('div.' + ourClass).show();
    //     }
    //
    //
    //     if ($('.col-three-grid .filter-outer .filter-wrap .year-wrapper span.all').hasClass('active')) {
    //         $('.col-three-grid .grid-wrapper h2').show();
    //     }
    //     if ($('.col-three-grid .filter-outer .filter-wrap .year-wrapper span.c-year').hasClass('active')) {
    //         $('.col-three-grid .grid-wrapper h2.c-year-title').show();
    //         $('.col-three-grid .grid-wrapper h2.n-year-title').hide();
    //     }
    //     if ($('.col-three-grid .filter-outer .filter-wrap .year-wrapper span.n-year').hasClass('active')) {
    //         $('.col-three-grid .grid-wrapper h2.n-year-title').show();
    //         $('.col-three-grid .grid-wrapper h2.c-year-title').hide();
    //     }
    //     return false;
    // });


    function wrappBlock() {
      $("body .col-three-grid .grid-wrapper .views-element-container .card-box.show-block").clone().appendTo('body .col-three-grid .timeline-container');
    }

    // $(document).ready(function () {
    //   $(".col-three-grid .grid-wrapper .views-element-container .card-box").addClass("show-block");
    //   wrappBlock();
    // });

    $(document).on('click', '.col-three-grid .filter-outer .filter-wrap .year-wrapper span', function () {
      if (!$(this).hasClass('active')) {
        $(".col-three-grid .timeline-container").empty();
        $('.col-three-grid .filter-outer .filter-wrap .year-wrapper span').removeClass('active');
        $(this).addClass('active');

        var filtervalue = $(this).attr('data-type');
        if (filtervalue === 'all') {
          // $(".col-three-grid .grid-wrapper .views-element-container .card-box[data-year]").removeClass('show-block');
          $(".col-three-grid .grid-wrapper .card-box").addClass('show-block').css({'display': 'block'});
          $(".col-three-grid .grid-wrapper .views-element-container h3").addClass('show-block').css({'display': 'block'});
          $('.we-no-result').css({'display': 'none'});
          // wrappBlock();
        } else {
          $(".col-three-grid .grid-wrapper .views-element-container h3").each(function () {
            var filterdata = $(this).attr('data-title');
            if (filtervalue === filterdata) {
              $(this).addClass('show-block').css({'display': 'block'});
            } else {
              $(this).removeClass('show-block').css({'display': 'none'});
            }
          });

          $(".col-three-grid .grid-wrapper .card-box").each(function () {
            var filterdata = $(this).attr('data-year');
            if (filtervalue === filterdata) {
              $(this).addClass('show-block').css({'display': 'block'});
            } else {
              $(this).removeClass('show-block').css({'display': 'none'});
            }
          });
        }

        if ($(".col-three-grid .grid-wrapper .views-element-container").find('h3').hasClass('show-block')) {
          $('.we-no-result').css({'display': 'none'});
          console.log(1);
        } else {
          $('.we-no-result').css({'display': 'block'});
          console.log(2);
        }
      }
    });

    setTimeout(function () {
      setAttr();
      setAttrText();
    }, 1500);


    $(document).on('change', '.col-three-grid .event-location .recent-wrapper', function (e) {
      var value = $(this).val();
      var value2 = $('#views-exposed-form-event-block-3 .form-item-field-trade-show-location-target-id select, #views-exposed-form-event-block-5 .form-item-field-trade-show-location-target-id select').val();
      var value3 = $('#views-exposed-form-tradeshow-block-1 .form-item-field-trade-show-location-target-id select').val();

      if (value !== value2) {
        $('#views-exposed-form-event-block-3 .form-item-field-trade-show-location-target-id select, #views-exposed-form-event-block-5 .form-item-field-trade-show-location-target-id select').val(value).trigger('change');
        $('#views-exposed-form-event-block-3 .form-submit, #views-exposed-form-event-block-5 .form-submit').trigger('click');
        $('.col-three-grid .filter-outer .filter-wrap .year-wrapper .all').trigger('click');
      }

      if (value !== value3) {
        $('#views-exposed-form-tradeshow-block-1 .form-item-field-trade-show-location-target-id select').val(value).trigger('change');
        $('#views-exposed-form-tradeshow-block-1 .form-submit').trigger('click');
        $('.col-three-grid .filter-outer .filter-wrap .year-wrapper .all').trigger('click');
      }

      setTimeout(function () {
        setAttr();
      }, 1500);

      setTimeout(function () {
        limit_lines('.col-three-grid .grid-wrapper .card-box .card .card-body .inner-content p', 3);
        limit_lines('.col-three-grid .grid-wrapper .card-box .card-body .inner-content h4', 2);

        $('.col-three-grid .grid-wrapper .card-box .card-body .inner-content h4').matchHeight({byRow: 0});
        $('.col-three-grid .grid-wrapper .card-box .card-body .inner-content').matchHeight();
      }, 2500);

    });

  });

  $(".col-three-grid .filter-outer .filter-wrap button").on('click', function () {
    var text = $('.col-three-grid .filter-outer .filter-wrap input').val();
    // console.log(text);
    $('#views-exposed-form-event-block-3 .form-item-combine input, #views-exposed-form-event-block-5 .form-item-combine input').val(text);
    $('#views-exposed-form-event-block-3 .form-submit, #views-exposed-form-event-block-5 .form-submit').trigger('click');

    $('#views-exposed-form-tradeshow-block-1 .form-item-combine input').val(text);
    $('#views-exposed-form-tradeshow-block-1 .form-submit').trigger('click');
    $('.col-three-grid .filter-outer .filter-wrap .year-wrapper .all').trigger('click');

    setTimeout(function () {
      limit_lines('.col-three-grid .grid-wrapper .card-box .card .card-body .inner-content p', 3);
      limit_lines('.col-three-grid .grid-wrapper .card-box .card-body .inner-content h4', 2);

      $('.col-three-grid .grid-wrapper .card-box .card-body .inner-content h4').matchHeight({byRow: 0});
      $('.col-three-grid .grid-wrapper .card-box .card-body .inner-content').matchHeight();
    }, 1500);

    setTimeout(function () {
      setAttr();
    }, 1500);
  });

  $("body .col-three-grid .filter-outer .filter-wrap input").on("keyup", function (event) {
    // Number 13 is the "Enter" key on the keyboard
    if (event.keyCode === 13) {
      // Cancel the default action, if needed
      event.preventDefault();
      var text = $('.col-three-grid .filter-outer .filter-wrap input').val();
      // console.log(text);
      $('#views-exposed-form-event-block-3 .form-item-combine input, #views-exposed-form-event-block-5 .form-item-combine input').val(text);
      $('#views-exposed-form-event-block-3 .form-submit, #views-exposed-form-event-block-5 .form-submit').trigger('click');

      $('#views-exposed-form-tradeshow-block-1 .form-item-combine input').val(text);
      $('#views-exposed-form-tradeshow-block-1 .form-submit').trigger('click');
      $('.col-three-grid .filter-outer .filter-wrap .year-wrapper .all').trigger('click');

      setTimeout(function () {
        limit_lines('.col-three-grid .grid-wrapper .card-box .card .card-body .inner-content p', 3);
        limit_lines('.col-three-grid .grid-wrapper .card-box .card-body .inner-content h4', 2);

        $('.col-three-grid .grid-wrapper .card-box .card-body .inner-content h4').matchHeight({byRow: 0});
        $('.col-three-grid .grid-wrapper .card-box .card-body .inner-content').matchHeight();
      }, 1500);

      setTimeout(function () {
        setAttr();
      }, 1500);
    }
  });

  $(window).resize(function () {
    setTimeout(function () {
      limit_lines('.col-three-grid .grid-wrapper .card-box .card .card-body .inner-content p', 3);
      limit_lines('.col-three-grid .grid-wrapper .card-box .card-body .inner-content h4', 2);
    }, 1500);
  });

})(jQuery);